export default function Gallery({ images, id, options }) {
  // layout: split || stacked
  // size: full || inline

  // 50/50
  // 100/100

  const config = {
    width: {
      full: "px-6 lg:px-16 w-full mx-auto",
      inline: "w-full max-w-screen-md mx-auto md:px-0",
    },
    grid: {
      1: "grid-cols-1",
      2: "grid-cols-1 md:grid-cols-2",
      3: "grid-cols-1 md:grid-cols-3",
      4: "grid-cols-1 md:grid-cols-4",
    },
  };

  return (
    <div
      className={`${config.width[options.width]} grid ${
        config.grid[options.grid]
      } gap-4 mb-8 py-4 ${options?.includeBackground ? "bg-slate-100" : ""}`}
    >
      {images.map((image, idx) => (
        <div key={"image" + idx}>
          <img
            alt={image?.alt ? image.alt : ""}
            src={require(`../routes/posts/caseStudies/${id}/media/${image.source}`)}
            className="h-auto max-w-full w-full object-cover object-center"
          />
          <div className="w-full pt-2 text-sm italic text-slate-600">
            {image?.alt}
          </div>
        </div>
      ))}
    </div>
  );
}
